<template>
    <section>

      <v-alert
      v-if="display_alert"
      :type="alert_type"
      dismissible
      >
      {{ alert_text }}
      </v-alert>

      <v-stepper v-model="current_step">
        <v-stepper-header>
          <v-stepper-step
            :complete="current_step > 1"
            step="1"
          >
            Tell us about yourself
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            :complete="current_step > 2"
            step="2"
          >Fund your Account</v-stepper-step>

          <v-stepper-step
            :complete="current_step > 3"
            step="3"
          >Send Cards to your Kids</v-stepper-step>

          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
              <v-container>
                <v-row v-if="ask_role">
                  <v-col>
                    <v-card
                    class="mx-auto"
                    max-width="344"
                    >
                      <v-img
                        src="@/assets/images/parent.jpg"
                        height="300px"
                      ></v-img>

                      <v-card-title>
                        I'm a Parent
                      </v-card-title>

                      <v-card-actions>
                        <v-btn
                          color="primary"
                          rounded
                          @click="select_role('parent')"
                        >
                          Select
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card
                    class="mx-auto"
                    max-width="344"
                    >
                      <v-img
                        src="@/assets/images/child.jpg"
                        height="300px"
                      ></v-img>

                      <v-card-title>
                        I'm a Child
                      </v-card-title>

                      <v-card-actions>
                        <v-btn
                          color="primary"
                          rounded
                          @click="select_role('child')"
                        >
                          Select
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="role=='parent'">
                  <v-container>
                    <v-row>
                      <v-text-field
                        label="Your full name"
                        v-model="full_name"
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        label="Your e-mail address"
                        v-model="email_address"
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        label="Your billing address"
                        v-model="billing_address.line_1"
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        label="City"
                        v-model="billing_address.city"
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        label="Postal Code"
                        v-model="billing_address.postal_code"
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        label="Province"
                        v-model="billing_address.state"
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-select
                        :items="country_codes"
                        label="Country"
                        v-model="billing_address.country_code"
                      ></v-select>
                    </v-row>

                    <v-row>
                      <v-checkbox
                        v-model="consent_opt_in"
                        label="Consent opt-in"
                      ></v-checkbox>
                    </v-row>

                    <v-row>
                      <v-btn type='submit' :waiting_result="waiting_result" @click='create_account'>Next</v-btn>
                    </v-row>
                  </v-container>
                </v-row>
                <v-row v-if="role=='child'">
                  <h2>Please ask your parent to sign up first at <a href='www.cub.cash'>www.cub.cash</a>, and send you the invite link to join.</h2>
                </v-row>
              </v-container>            
          </v-stepper-content>

          <v-stepper-content step="2">
            <fund :user="user" :api_prefix="api_prefix" :full_name="full_name" :email_address="email_address" @funded="funded"></fund>
            <v-btn type='submit' @click='current_step=1'>Back</v-btn>
          </v-stepper-content>
          <v-stepper-content step="3">
            <family :user="user" :api_prefix="api_prefix"></family>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </section>
</template>

<script>
import Fund from "@/components/Fund.vue";
import Family from "@/components/Family.vue";

export default {
    props: ['user','subscription_plan','api_prefix'],
    data() {
        return {
          current_step: 1,
          is_mobile: false,
          invite_link: "",
          waiting_result: false,
          error: false,
          display_alert: false,
          alert_type: "success",
          ask_role: true,
          country_codes: [{'text': 'Austria', 'value': 'AT'}, {'text': 'Belgium', 'value': 'BE'}, 
          {'text': 'Cyprus', 'value': 'CY'}, {'text': 'Estonia', 'value': 'EE'}, 
          {'text': 'Finland', 'value': 'FI'}, {'text': 'France', 'value': 'FR'},
          {'text': 'Germany', 'value': 'DE'}, {'text': 'Greece', 'value': 'GR'},
          {'text': 'Ireland', 'value': 'IE'}, {'text': 'Italy', 'value': 'IT'},
          {'text': 'Latvia', 'value': 'LV'}, {'text': 'Lithuania', 'value': 'LT'},
          {'text': 'Luxembourg', 'value': 'LU'}, {'text': 'Malta', 'value': 'MT'},
          {'text': 'Netherlands', 'value': 'NL'}, {'text': 'Portugal', 'value': 'PT'},
          {'text': 'Slovakia', 'value': 'SK'}, {'text': 'Slovenia', 'value': 'SI'}, {'text': 'Spain', 'value': 'ES'}, {'text': 'United States', 'value': 'US'}],
          consent_opt_in: false,
          full_name: null,
          email_address: null,
          role: null,
          billing_address: {"line_1": null, "city": null, "country_code": null, "postal_code": null, "state": null},
          selected_role: null,
        };
    },
    components: {
      'fund': Fund,
      'family': Family,
    },
    mounted: function() 
    {
      var step = this.$route.params.step;
      if(step!=null)
      {
        if(step == 1 || step ==2 || step == 3)
        this.current_step = parseInt(this.$route.params.step);
      }

      this.is_mobile = ('ontouchstart' in document.documentElement && navigator.userAgent.match(/Mobi/));

      window.analytics.page('Signup');
    },
    computed: {
      
    },
    methods: {
      async funded()
      {
        this.current_step = 3
      },
      async select_role(role)
      {
        this.role = role
        this.ask_role = false
      },
      async create_account()
      {
        try
        {
          let self = this;
          self.waiting_result = true;
          var response = await self.$http.post(self.api_prefix + '/account',
          {
            "full_name": self.full_name,
            "email": self.email_address,
            "billing_address": self.billing_address,
            "language_preference": navigator.language,
            "consent_opt_in": self.consent_opt_in
          },
          );
          console.log(response);
          if(response.data!=null)
          {
            self.current_step = 2;
            let auth_token = response.data.auth_token
            if(auth_token!=null)
            {
              localStorage.setItem('auth_token', auth_token)
              self.$emit('refresh_auth_token')
            }
          }
          self.waiting_result = false;
        }
        catch (error)
        {
          console.error(error);
        }
      }
    },
};
</script>

<style scoped>
#waiting_result_spinner
{
    margin: 0 auto;
    display: block;
}
</style>